export const defaultUser = () => ({
    id: null,
    name: '',
    login: '',
    password: '',
    permissions: []
});
